// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewEventPage_NewEventPage__fEqCZ .NewEventPage_BackButton__etdEt {
  margin: 0 0 10px;
}
.NewEventPage_NewEventPage__fEqCZ .NewEventPage_Button__xxrei {
  margin: 30px 0 0;
}
.NewEventPage_NewEventPage__fEqCZ .NewEventPage_Errors__I7oOT {
  margin: 10px 0 0;
}
.NewEventPage_NewEventPage__fEqCZ .NewEventPage_Errors__I7oOT .NewEventPage_ErrorsItem__KjlBV {
  color: #ff0000;
}`, "",{"version":3,"sources":["webpack://./src/components/NewEventPage/NewEventPage.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAMI;EACI,gBAAA;AALR;AAQI;EACI,gBAAA;AANR;AASI;EACI,gBAAA;AAPR;AASQ;EACI,cCjBA;ADUZ","sourcesContent":["@use '../../variables.scss' as *;\n\n.NewEventPage {\n    .Title {\n    }\n\n    .BackButton {\n        margin: 0 0 10px;\n    }\n\n    .Button {\n        margin: 30px 0 0;\n    }\n\n    .Errors {\n        margin: 10px 0 0;\n\n        .ErrorsItem {\n            color: $color-red;\n        }\n    }\n}\n","$box-shadow-default: 0 2px 10px rgba(0, 0, 0, 0.5);\n$color-red: #ff0000;\n$color-white: #ffffff;\n$color-blue: #228be6;\n$color-peach: #fff3df;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NewEventPage": `NewEventPage_NewEventPage__fEqCZ`,
	"BackButton": `NewEventPage_BackButton__etdEt`,
	"Button": `NewEventPage_Button__xxrei`,
	"Errors": `NewEventPage_Errors__I7oOT`,
	"ErrorsItem": `NewEventPage_ErrorsItem__KjlBV`
};
export default ___CSS_LOADER_EXPORT___;
